// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ResetPasswordInternalRequestModel {
    static getAttributeTypeMap() {
        return ResetPasswordInternalRequestModel.attributeTypeMap;
    }
}
ResetPasswordInternalRequestModel.discriminator = undefined;
ResetPasswordInternalRequestModel.additionalProperties = false;
ResetPasswordInternalRequestModel.attributeTypeMap = [
    {
        "name": "emails",
        "baseName": "emails",
        "type": ""
    },
    {
        "name": "portalUserDatabase",
        "baseName": "portalUserDatabase",
        "type": "string"
    },
    {
        "name": "portalClientId",
        "baseName": "portalClientId",
        "type": "string"
    },
];
//# sourceMappingURL=resetPasswordInternalRequestModel.js.map